import Reflux from 'reflux';
import EventData from 'shared/data/Event';
import readOnlyHelper from 'flux/helpers/readOnlyHelper';

let async = { asyncResult: true };

const asyncReadOnlyCfg = readOnlyHelper.actionConfigFactory(async);

let EventCrewListActions = Reflux.createActions({
  populate: async,
  updateRole: asyncReadOnlyCfg,
  createRole: asyncReadOnlyCfg,
  removeRole: asyncReadOnlyCfg,
  resendInviteEmail: asyncReadOnlyCfg,
});

EventCrewListActions.populate.listenAndPromise(EventData.getRoles);
EventCrewListActions.updateRole.listenAndPromise(EventData.updateRole);
EventCrewListActions.createRole.listenAndPromise(EventData.createRole);
EventCrewListActions.removeRole.listenAndPromise(EventData.removeRole);
EventCrewListActions.resendInviteEmail.listenAndPromise(
  EventData.resendInviteEmail,
);

export default EventCrewListActions;
